<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Create Outline</h2>
    </div>
    <div class="sm:grid grid-cols-2 gap-4">
      <div class="grid grid-cols-1 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-6">
          <!-- BEGIN: Form Layout -->
          <div class="intro-y box p-5">
            <div>
              <label>Workshop Name</label>
              <input
                v-model="model.name"
                type="text"
                class="input w-full border mt-2"
                placeholder="Input text"
              />
            </div>
            <div class="mt-3">
              <label>Category</label>
              <div class="mt-2">
                <TailSelect
                  v-model="categories"
                  :options="{
                    hideSelected: true,
                    hideDisabled: true,
                    multiLimit: 15,
                    multiShowCount: false,
                    multiContainer: true,
                    classNames: 'w-full'
                  }"
                  multiple
                >
                  <option value="Data Science">Data Science</option>
                  <option value="Digital Marketing">Digital Marketing</option>
                  <option value="Coding">Coding</option>
                  <option value="Tech Business">Tech Business</option>
                  <option value="Others">Others</option>
                </TailSelect>
              </div>
            </div>
            <!-- <div class="mt-3">
            <label>Quantity</label>
            <div class="relative mt-2">
              <input
                type="text"
                class="input pr-12 w-full border col-span-4"
                placeholder="Price"
              />
              <div
                class="absolute top-0 right-0 rounded-r w-10 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
              >
                pcs
              </div>
            </div>
          </div> -->
            <!-- <div class="mt-3">
            <label>Weight</label>
            <div class="relative mt-2">
              <input
                type="text"
                class="input pr-16 w-full border col-span-4"
                placeholder="Price"
              />
              <div
                class="absolute top-0 right-0 rounded-r w-16 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
              >
                grams
              </div>
            </div>
          </div> -->
            <div class="mt-3">
<!--              <label>Fee</label>-->
              <div class="sm:grid grid-cols-3 gap-2">
                <div class="relative mt-2">
                  <div
                    class="absolute top-0 left-0 rounded-l w-12 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                  >
                    Fee
                  </div>
                  <div class="pl-3">
                    <input
                      v-model="model.fees"
                      type="text"
                      class="input pl-12 w-full border col-span-4"
                      placeholder="Amount"
                    />
                  </div>
                </div>
                <div class="relative mt-2">
                <div
                  class="absolute top-0 left-0 rounded-l w-20 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                >
                  Duration
                </div>
                <div class="pl-3">
                  <input
                    v-model="model.duration"
                    type="text"
                    class="input pl-20 w-full border col-span-4"
                    placeholder="Hour(s)"
                  />
                </div>
              </div>

                <!-- <div class="relative mt-2">
                <div
                  class="absolute top-0 left-0 rounded-l w-12 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600"
                >
                  Bulk
                </div>
                <div class="pl-3">
                  <input
                    type="text"
                    class="input pl-12 w-full border col-span-4"
                    placeholder="Price"
                  />
                </div>
              </div> -->
              </div>
            </div>
            <div class="mt-3">
              <label>Workshop Date</label>
              <!--              <LitePicker-->
              <!--                v-model="salesReportFilter"-->
              <!--                :options="{-->
              <!--                  autoApply: false,-->
              <!--                  showWeekNumbers: true,-->
              <!--                  dropdowns: {-->
              <!--                    minYear: 1990,-->
              <!--                    maxYear: null,-->
              <!--                    months: true,-->
              <!--                    years: true-->
              <!--                  }-->
              <!--                }"-->
              <!--                class="input w-full border mt-2"-->
              <!--              />-->
              <input type="datetime-local" id="meeting-time" name="meeting-time" v-model="time" class="input w-full border mt-2"/>
            </div>
            <!-- <div class="mt-3">
            <label>Active Status</label>
            <div class="mt-2">
              <input type="checkbox" class="input input--switch border" />
            </div>
          </div> -->
            <div class="mt-3">
              <label>Description</label>
              <!-- <div class="mt-2">
                <CKEditor
                  v-model="editorData"
                  :editor="classicEditor"
                  :config="simpleEditorConfig"
                />
              </div> -->
              <div class="mt-5">
                  <CKEditor
                    v-model="model.description"
                    :editor="classicEditor"
                    :config="editorConfig"
                  />
                </div>
            </div>
            <div class="my-5" v-if="isTeacher">
              <h1>Provide a relevant work sample</h1>
              <label>(Provide a link that contains an existing video of you teaching any course online)</label>
<!--              <uploader @uploaded="sampleUploaded"></uploader> OR,-->
              <input
                  v-model="videoLink"
                  type="text"
                  class="input w-full border mt-2"
                  placeholder="Paste your link here"
              />
            </div>
            <div class="mt-5 box p-5">
              <div class="mt-3">
                <label>Upload a high resolution image</label>
                <div
                    class="border-2 border-dashed dark:border-dark-5 rounded-md mt-3 pt-4"
                >
                  <div class="px-4">
                    <uploader @uploaded="pictureUploaded"></uploader>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 box p-5">
              <div class="mt-3">
                <label>Upload course outline</label>
                <div
                    class="border-2 border-dashed dark:border-dark-5 rounded-md mt-3 pt-4"
                >
                  <div class="px-4">
                    <uploader @uploaded="courseOutlineUploaded"></uploader>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right mt-5">
              <button
                type="button"
                class="button w-24 border dark:border-dark-5 text-gray-700 dark:text-gray-300 mr-1"
              >
                Cancel
              </button>
              <button type="button" class="button w-24 bg-theme-1 text-white" @click="submit">
                Submit
              </button>
            </div>
<!--            <FilePond></FilePond>-->
          </div>
          <!-- END: Form Layout -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import FilePond from "@/components/FilePhond"
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import UnderlinePlugin from "@ckeditor/ckeditor5-basic-styles/src/underline";
import StrikethroughPlugin from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import CodePlugin from "@ckeditor/ckeditor5-basic-styles/src/code";
import SubscriptPlugin from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import SuperscriptPlugin from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import EasyImage from "@ckeditor/ckeditor5-easy-image/src/easyimage";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import HeadingButtonsUI from "@ckeditor/ckeditor5-heading/src/headingbuttonsui";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";

export default {
  components: {
    CKEditor: CKEditor.component
    // FilePond: FilePond
  },
  data() {
    return {
      time: "",
      model: {
        files:[]
      },
      categories: ["Data Science"],
      tags: ["1", "2"],
      salesReportFilter: "",
      classicEditor: ClassicEditor,
      editorConfig: {
        cloudServices: {
          tokenUrl: "",
          uploadUrl: ""
        },
        plugins: [
          Font,
          EssentialsPlugin,
          BoldPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          CodePlugin,
          SubscriptPlugin,
          SuperscriptPlugin,
          EasyImage,
          Heading,
          HeadingButtonsUI,
          Highlight
        ],
        toolbar: {
          items: [
            //"fontSize",
            //"fontFamily",
            //"fontColor",
            //"fontBackgroundColor",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            //"code",
            //"subscript",
            //"superscript",
            "link",
            "undo",
            "redo",
            //"imageUpload",
            //"highlight"
          ]
        }
      },
      editorData: "<p>Please provide a description of your workshop</p>",
      dashboardInfo : {},
      isTeacher: false,
      videoLink: ""
    };
  },
  methods: {
    parseTime() {
      let d = new Date(this.time)
      return d.getTime() / 1000
    },
    submit() {
      if (this.isTeacher) {
        if (this.videoLink == "") {
          alert("Work sample video link is mandatory!")
          return
        }
        this.model.description += ` WORK SAMPLE LINK: <a href="${this.videoLink}">Link</a>`
      }
      this.model.categories = this.categories[0]
      this.model.workshop_ts = this.parseTime()
      this.model.fees = this.model.fees * 1.0
      this.model.duration = parseInt(this.model.duration)
      this.$upskill.addWR(this.model).then(() => {
        this.$router.push({name: "side-menu-crud-data-list"})
      })
    },
    courseOutlineUploaded(e) {
      this.model.files.push(e.response)
    },
    pictureUploaded(e) {
      this.model.files.push(e.response)
    },
    sampleUploaded(e) {
      console.log(e.response)
    },
    getProfileInfo() {
      this.$upskill.trainerDashboard().then(res => {
        this.dashboardInfo = res.data;
        if (this.dashboardInfo.user.occupation == "upskill-teacher") {
          this.isTeacher = true
        }
      });
    }
  },
  created() {
    this.getProfileInfo()
  }
};
</script>

